<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Privacy Policy: We Respect Your Privacy!</h3>
        <p>We respect your privacy. Your information will not be shared with any third party and you may unsubscribe at anytime.</p>
        <h4>Privacy Overview</h4>
        <p>All information submitted to StumptheSpread.com is confidential and is used only for market research purposes.  This information will not be shared, traded, or sold to any third party companies.  Information we maintain is used to improve the quality of our site.  It will only be used to communicate with visitors who want to receive additional information. An anonymous visitor to our site will maintain their anonymity under all circumstances. StumptheSpread.com does not attempt to identify visitors if they do not voluntarily register on the site. If you no longer want to receive e-mail communications from our site, please use the unsubscribe link provided on every e-mail we send out.</p>
        <h4>Personal Information</h4>
        <p>All personal data you provide to StumptheSpread.com is confidential.  This may include your name, address, phone number, and any other details.  This data is never sold, traded, or used for any purpose other than to improve the website.</p>
        <h4>Payment Information</h4>
        <p>Payments are submitted through a third party processor.  We do not keep your credit/debit card number or any other payment-related information.  StumptheSpread.com uses only the most respected payment processors, but we cannot be held responsible for the privacy of their sites.  We encourage you to examine their privacy policy if you have any questions about the information they retain. </p>
        <p>Any further questions can be directed to support@stumpthespread.com</p>
      </div>
      <!-- main-colum END here -->
      <sidebar :testimonial="testimonial"></sidebar>
    </div>
    <!-- container END here -->
  </div>
  <!-- content END here -->
</template>

<script>
import Sidebar from '../components/sidebar.vue'
import TestimonialRepository from '../data/testimonial.repository.js'
export default {
  components: {
    'sidebar': Sidebar
  },
  data () {
    return {
      testimonial: ''
    }
  },
  created () {
    TestimonialRepository.getTestimonials(1).then(test => {
      this.testimonial = test
    })
  },
  metaInfo: {
    title: 'Privacy Policy'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Privacy.vue?4409fcd8